import { useEmbarcacaoVazaoBombas } from "../../../../hooks/use-embarcacao-vazao-bombas";
import { EMPTY_FIELD_PLACEHOLDER, latestAtualizacao } from "../../../detail-format/detail-format";
import { buildDetailFields } from "../../../detail-format/detail-fields";
import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import {
  VAZAO_BOMBAS_EMPTY_STATE,
  VAZAO_BOMBAS_FIELDS,
  VAZAO_BOMBAS_ID,
  VAZAO_BOMBAS_LOADING_MESSAGE,
  VAZAO_BOMBAS_TEST_ID,
  VAZAO_BOMBAS_TITLE,
} from "./vazao-bombas-section.constants";

/** Seção Vazão das Bombas do detalhamento da embarcação: somente leitura, com os campos já formatados para a View. */
export function useVazaoBombasSection({
  embarcacaoId,
  onReauthenticate,
}: EmbarcacaoDetailSectionProps) {
  const { status, vazaoBombas, errorMessage, reload } = useEmbarcacaoVazaoBombas(embarcacaoId);

  return {
    id: VAZAO_BOMBAS_ID,
    title: VAZAO_BOMBAS_TITLE,
    testId: VAZAO_BOMBAS_TEST_ID,
    fieldsTestId: `${VAZAO_BOMBAS_TEST_ID}-fields`,
    status,
    errorMessage,
    loadingMessage: VAZAO_BOMBAS_LOADING_MESSAGE,
    emptyContent: VAZAO_BOMBAS_EMPTY_STATE,
    onReauthenticate,
    onRetry: reload,
    // Só há data de atualização a exibir quando a seção tem dados.
    ultimaAtualizacao: vazaoBombas
      ? latestAtualizacao([vazaoBombas.ultimaAtualizacao, vazaoBombas.atualizacaoVazaoBomba])
      : undefined,
    fields: buildDetailFields(
      vazaoBombas,
      VAZAO_BOMBAS_FIELDS,
      VAZAO_BOMBAS_TEST_ID,
      EMPTY_FIELD_PLACEHOLDER,
    ),
  };
}
